// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_5-0";
export var skeletonCard = "_5-1";